import axiosInstance, { API_GET, API_POST, API_PUT } from "../config/axiosConfig";
import * as constants from "../constants";

export async function putBannerImage(roomId, data, token) {
    try {
        const response = await axiosInstance.put(
            `${process.env.REACT_APP_CORE_API_URI}/v1/web/rooms/room_personalization_items/banner_image/${roomId}`,
            data,
            {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json; charset=UTF-8",
                },
            }
        );
        return response;
    } catch (error) {
        return error;
    }
}
export async function getPersonalizationItems(roomId) {
    try {
        const response = await API_GET(
            `${process.env.REACT_APP_CORE_API_URI}/v1/web/rooms/room_personalization_items/${roomId}`
        );
        return response;
    } catch (error) {
        return error;
    }
}
export async function putPersonalizationItem(roomPersonalizationItemId, data) {
    try {
        const response = await API_PUT(
            `${process.env.REACT_APP_CORE_API_URI}/v1/web/rooms/room_personalization_items/${roomPersonalizationItemId}`,
            data
        );
        return response;
    } catch (error) {
        return error;
    }
}

export const getUserRoomPermission = async (roomId, token) => {
    try {
        const response = await axiosInstance.get(
            `${process.env.REACT_APP_CORE_API_URI}/web/rooms/permission/${roomId}`,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.status === 200) {
            return true;
        }

        return false;
    } catch (error) {
        console.error("Error verifying token:", error);
        return false;
    }
};

export const getRoomSettingsById = async (id) => {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/rooms/${id}/settings`);

        if (response) {
            return response;
        }
    } catch (error) {
        console.error("Error grabbing room settings:", error);
        return null;
    }
};

export const getArcadeRoomGames = async (roomId) => {
    try {
        const respAxios = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/clients/arcade-games/${roomId}`);
        if (respAxios?.status === 200) {
            return respAxios?.data;
        }
        if (respAxios?.status !== 200) {
            const sendDefault = constants.DEFAULT_ARCADE_GAMES;
            return sendDefault;
        }
    } catch (error) {
        console.error("Error fetching arcade games:", error);
        const sendDefault = constants.DEFAULT_ARCADE_GAMES;
        return sendDefault;
    }
};

export const verifyRoomInviteToken = async (roomInviteLinkId) => {
    try {
        const response = await axiosInstance.get(
            `${process.env.REACT_APP_CORE_API_URI}/web/rooms/verify-invite/${roomInviteLinkId}`,
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=UTF-8",
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error verifying token:", error);
        return error;
    }
};

export const UpdateRoomInviteUserData = async (roomId, userId, inviteSettings, action) => {
    try {
        const response = await API_PUT(
            `${process.env.REACT_APP_CORE_API_URI}/web/rooms/invite/${roomId}`,
            {
                inviteSettings,
                userId,
                action,
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json; charset=UTF-8",
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error updating room invite user data:", error);
        return error;
    }
};

export const AddRoomTypePrefab = async (data) => {
    try {
        return await API_POST(`${process.env.REACT_APP_CORE_API_URI}/web/rooms/prefabs`, data);
    } catch (error) {
        console.error("Error adding room type prefab:", error);
        return error;
    }
};

export const UpdateRoomTypePrefab = async (id, data) => {
    try {
        return await API_PUT(`${process.env.REACT_APP_CORE_API_URI}/web/rooms/prefabs/${id}`, data);
    } catch (error) {
        console.error("Error adding room type prefab:", error);
        return error;
    }
};

export const GetRoomTypePrefabs = async () => {
    try {
        return await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/rooms/prefabs`);
    } catch (error) {
        console.error("Error adding room type prefab:", error);
        return error;
    }
};

export const getUsersRooms = async (userId) => {
    try {
        const respAxios = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/users/${userId}/rooms-users`);
        if (respAxios?.status === 200) {
            return respAxios?.data?.data;
        }
        return [];
    } catch (err) {
        console.log("err", err);
        return [];
    }
};

export async function getRoomById(id) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/rooms/${id}`;
        const respAxios = await API_GET(url);
        if (respAxios?.status === 200) {
            return respAxios?.data?.room;
        }
        return null;
    } catch (err) {
        console.error("Error fetching data:", err);
        return null;
    }
}

export async function updateRoomSettingsById(roomId, data) {
    try {
        console.log("data", data);
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/rooms/${roomId}/settings`;
        const respAxios = await API_PUT(url, data);
        return respAxios;
    } catch (err) {
        console.log("err", err);
        return err;
    }
}
